<template>
	<div class='journal-lpo'>

		<div class='header flex-block'>
			<!-- <span >
				{{ selectedList.map(item => item.section_lp) }}
			</span> -->
			<button v-if='selectedList.length' @click='addToGroup'>Добавить выбранные обследования в группу</button>
			<div class='pagination-container'>
				<VPagination
					class='pagination'
					:current='currentPage'
					:total='totalPages'
					@page-change='onPageChange'
				/>
			</div>
		</div>

		<div class='table-container flex-block'>
			<table class='table-lpo-list'>
				<thead>
					<tr>
						<th>Федеральный округ</th>
						<th>Субъект РФ</th>
						<th>Лесничество</th>
						<th>Участковое</th>
						<th>Урочище/Дача</th>
						<th>Квартал</th>
						<th>Выдел</th>
						<th>ЛП выдел</th>
						<th>Способ ЛПО</th>
						<th>Дата</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for='lpo in lpoList'
						:key='lpo.lpo_id'
					>
						<td>{{ lpo.fo }}</td>
						<td>{{ lpo.region }}</td>
						<td>{{ lpo.forestry }}</td>
						<td>{{ lpo.localforestry }}</td>
						<td>{{ lpo.subforestry }}</td>
						<td>{{ lpo.area }}</td>
						<td>{{ lpo.section }}</td>
						<td>{{ lpo.section_lp }}</td>
						<td>{{ lpo.inspection_type }}</td>
						<td>{{ normalizeDate(lpo) }}</td>
						<td>
							<custom-p-checkbox
								v-model='selectedList'
								multiple
								:multipleValue='lpo'
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>
</template>

<script>
	const GET_JOURNAL_LPO = process.env.VUE_APP_ROOT_API + 'get_journal_lpo.php';

	export default {
		name: 'JournalLpo',
		props: {
			filter: {
				type: String,
				default: ''
			}
		},
		data: () => ({
			selectedList: [],
		}),
		computed: {
			lpoList() {
				return this.$store.state.journalLpo['lpoListForGroup'];
			},

			currentPage() {
				return this.$store.state.journalLpo['currentPageForGroup'];
			},
			perPage() {
				return this.$store.state.journalLpo['perPageForGroup'];
			},
			totalPages() {
				return this.$store.getters['journalLpo/totalPagesForGroup'];

			}
		},
		methods: {

			onSelectLpo(event, lpo) {
				const checked =	event.target.checked;

				if (checked) {
					this.selectedList.push(lpo);
				} else {
					const index = this.selectedList.findIndex(item => item === lpo);
					this.selectedList.splice(index, 1);
				}
			},

			addToGroup() {
				// return;

				this.$store.dispatch('lpoData/addToGroup', this.selectedList).then(res => {
					this.$store.dispatch('lpoData/getActLpoList');
					this.$router.push({ name: 'act-lpo-list' });
				});
			},

			onPageChange(page) {
				this.$store.dispatch('journalLpo/changePageForGroup', page);
			},

			getJournalLpo(filter) {
				this.$store.dispatch('journalLpo/getLpoListForGroup', filter);
			},

			normalizeDate(lpo) {
				if (!lpo || !lpo.inspection_date) {
					return;
				}

				const date = lpo.inspection_date;
				return date.split('-').reverse().join('.');
			}
		},
		created() {
			// console.log('filter: ', this.filter);
			if (!this.filter) {
				this.$router.push({ name: 'act-lpo-list' });
			}
			this.getJournalLpo(this.filter);
			// console.log('route', this.$route);
		}
	};
</script>

<style scoped>
	.content-list-lpo {
		display: flex;
		flex-direction: column;
		height:100vh;
	}

	.content-component {
		width: 100%;
	}

	/* HEADER */

	.header {
		/*height: 32px;*/
		padding: 10px 20px 0 40px;
	}
	.header::after {
		content: '';
		clear: both;
		display: table;
	}

	.fo-region-span {
		color: #777;
		cursor: pointer;
		font-family: 'Roboto Black';
		font-size: 24px;
		text-decoration: underline;
	}
	.fo-region-span:hover {
		color: #999;
	}


	.pagination-container {
		float: right;
	}

	/* TABLE */

	.table-container {
		/*border-bottom: 1px solid #c0c0c0;*/
		height: calc(100vh - 94px);
		overflow-y: scroll;

	}

	.table-lpo-list {
		border-collapse: separate;
		border-spacing: 0;

		/*font-size: 13px;*/
		text-align: center;
		
		width: 100%;
	}
	.table-lpo-list th,
	.table-lpo-list td {
		border-top: 1px solid #c0c0c0;
		border-left: 1px solid #c0c0c0;

		vertical-align: middle;
	}

	.table-lpo-list th {
		background-color: #034444;
		color: #fff;
		font-weight: bold;
		padding: 12px 2px;
		
		position: sticky;
		top: 0;
	}

	.table-lpo-list td {
		cursor: pointer;
		padding: 4px 2px;
	}

	.table-lpo-list tbody tr:nth-child(even) td {
		background-color: #f7f7f7;
	}

	.table-lpo-list tbody tr:hover > td {
		background-color: #d8ecf3;
	}
	.table-lpo-list tbody tr.selected > td {
		background-color: #add8e6;
	}
	

</style>